<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 custom-title">{{ page_title }} Report</h3>
        </div>
    </div>
    <!-- Tabs: Admin & Coordinators (always visible once coordinator status is known) -->
    <div class="section mb-1 mt-1" v-show="isUserCoordinator && userAdminType">
        <div class="report-tabs-container">
            <!-- Admin tab: ONLY shown if user has admin_type = 'admin' -->
            <button 
                v-if="userAdminType === 'admin'"
                class="report-tab-btn" 
                :class="{ active: activeTab === 'admin' }" 
                @click="switchTab('admin')">
                Admin
            </button>
            <!-- Coordinator tab: shown for both 'coordinator' and 'admin' types -->
            <button 
                class="report-tab-btn" 
                :class="{ active: activeTab === 'coordinators' }" 
                @click="switchTab('coordinators')">
                Coordinator
            </button>
        </div>
    </div>
    
    <!-- Message when user is not a coordinator -->
    <div class="section mt-3" v-if="activeTab === 'coordinators' && !isUserCoordinator && !$route.params.coordinator_id && !loading_coordinator_check">
        <div class="card">
            <div class="card-body text-center py-5">
                <ion-icon name="people-outline" style="font-size: 64px; color: #ccc;"></ion-icon>
                <h3 class="mt-3 text-muted">No Mentors Have been assigned</h3>
                <p class="text-muted">You are not assigned as a coordinator for this campaign.</p>
            </div>
        </div>
    </div>
    
    <!-- Message when coordinator has no mentors assigned -->
    <div class="section mt-3" v-if="!loading_list && activeTab === 'coordinators' && isUserCoordinator && member_lists.length === 0">
        <div class="card">
            <div class="card-body text-center py-5">
                <ion-icon name="people-outline" style="font-size: 64px; color: #ccc;"></ion-icon>
                <h3 class="mt-3 text-muted">No Mentors Assigned</h3>
                <p class="text-muted">You don't have any mentors assigned as a coordinator yet.</p>
            </div>
        </div>
    </div>
    
    <div class="section inset mt-1 mb-1"
        v-if="(activeTab === 'admin' || (isUserCoordinator && activeTab === 'coordinators')) && !(activeTab === 'coordinators' && member_lists.length === 0 && !loading_list)">
        <div class="accordion" id="accordionExample2">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#accordion001" aria-expanded="false">
                        <ion-icon name="filter-outline" role="img" class="md hydrated"
                            aria-label="wallet outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="accordion001" class="accordion-collapse collapse" data-bs-parent="#accordionExample2">
                    <div class="accordion-body">
                        <div id="search" style="padding: 0px !important;">
                            <div class="form-group" v-if="(activeTab === 'admin' && (currentUser.user_level == 1 || (isUserCoordinator && userAdminType === 'admin' && userAdminLevel == 1))) || (activeTab === 'coordinators' && isUserCoordinator)">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_district">District</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_district"
                                        name="filter_district" id="select4" @change="getZoneList($event.target.value)">
                                        <option value>---All---</option>
                                        <option v-for="district in district_list" v-bind:value="district.id"
                                            v-bind:key="district.id">{{
                                                district.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group" v-if="(activeTab === 'admin' && (currentUser.user_level <= 2 || (isUserCoordinator && userAdminType === 'admin' && userAdminLevel <= 2))) || (activeTab === 'coordinators' && isUserCoordinator)">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_zone">Zone</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_zone"
                                        name="filter_zone" id="select4" @change="getUnitList($event.target.value)">
                                        <option value>---All---</option>
                                        <option v-for="zone in zone_list" v-bind:value="zone.id" v-bind:key="zone.id">{{
                                            zone.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group" v-if="(activeTab === 'admin' && (currentUser.user_level <= 3 || (isUserCoordinator && userAdminType === 'admin' && userAdminLevel <= 3))) || (activeTab === 'coordinators' && isUserCoordinator)">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_unit">Unit</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_unit"
                                        name="filter_unit" id="select4">
                                        <option value>---All---</option>
                                        <option v-for="unit in unit_list" v-bind:value="unit.id" v-bind:key="unit.id">{{
                                            unit.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_percentage">Completed Status</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_percentage"
                                        name="filter_percentage" id="select4">
                                        <option value>---All---</option>
                                        <option value="Completed">Completed</option>
                                        <option value="Started">Started</option>
                                        <option value="Not Started">Not Started</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_sex">Sex</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_sex"
                                        name="filter_sex" id="select4">
                                        <option value>---All---</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="clearFilter()">
                                        <ion-icon name="trash-bin-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="$route.params.coordinator_id ? getCoordinatorMentorsList() : getMembersList()">
                                        <ion-icon name="search-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="section" v-if="!loading_list && !(activeTab === 'coordinators' && !isUserCoordinator && !$route.params.coordinator_id) && !(activeTab === 'coordinators' && member_lists.length === 0)">
        <div class="row mt-1">
            <div class="col-12">
                <div class="stat-box">
                    <div class="title text-primary">Total</div>
                    <div class="value text-primary">{{ count_target }}</div>
                </div>
            </div>
            <div class="col-6 mt-1">
                <div class="stat-box">
                    <div class="title text-primary">Calling Done</div>
                    <div class="value text-success">{{ count_confirmed }}</div>
                </div>
            </div>
            <div class="col-6 mt-1">
                <div class="stat-box">
                    <div class="title text-primary">Calling Balance</div>
                    <div class="value text-danger">{{ count_total }}</div>
                </div>
            </div>
        </div>
        <!-- Featured Filter Counts (if featured_filter_1 is set) -->
        <div class="row mt-1" v-if="featuredFilterCounts && Object.keys(featuredFilterCounts).length > 0" style="margin-left: -5px; margin-right: -5px;">
            <div class="col-6 px-1 mb-1" v-for="(count, value) in featuredFilterCounts" :key="value">
                <div class="stat-box">
                    <div class="title text-primary">{{ value }}</div>
                    <div class="value text-info">{{ count }}</div>
                </div>
            </div>
        </div>
        <!-- Default Registered/Not Registered (if featured_filter_1 is not set) -->
        <div class="row mt-1" v-else>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title text-primary">Registered</div>
                    <div class="value text-success">{{ count_confirmed_reg }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title text-primary">Not Registered</div>
                    <div class="value text-danger">{{ count_balance_reg }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="section inset mt-1" v-if="!(activeTab === 'coordinators' && !isUserCoordinator && !$route.params.coordinator_id) && !(activeTab === 'coordinators' && member_lists.length === 0 && !loading_list)">
        <div id="search" style="padding: 0px !important;">
            <form class="search-form">
                <div class="row">
                    <!-- <div class="input-group">
                        <label class="block"><input type="radio" name="search_mode" value="mobile" v-model="search_mode">Mobile</label>
                        &nbsp;&nbsp;
                        <label class="block"><input type="radio" name="search_mode" value="reg_no" v-model="search_mode">Reg No</label>
                    </div> -->
                    <div class="input-group form-group" style="width:65%;">
                        <input type="text" placeholder="Search..." class="form-control" focus v-model="search_qry"
                            style="border-radius: 10px;" />
                    </div>
                    <div class="form-group pl-0" style="width:10% !important;">
                        <button type="button" :disabled="search_qry ? false : true" class="btn btn-outline-primary me-1"
                            @click="$route.params.coordinator_id ? getCoordinatorMentorsList() : getMembersList()">
                            <ion-icon name="search-outline" role="img" class="md hydrated"
                                aria-label="newspaper outline"></ion-icon>Search
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="section text-center" v-if="loading_list && !(activeTab === 'coordinators' && !isUserCoordinator && !$route.params.coordinator_id) && !(activeTab === 'coordinators' && member_lists.length === 0)">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section mt-0 mb-2" v-if="!loading_list && !(activeTab === 'coordinators' && !isUserCoordinator && !$route.params.coordinator_id) && !(activeTab === 'coordinators' && member_lists.length === 0)">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Total</th>
                            <th scope="col">Done</th>
                            <th scope="col">Balance</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(sub_level,index) in member_lists" v-bind:key="sub_level">
                            <td class="text-primary font-dark text-left">
                                <span class="text-primary"><b> {{ index+1 }}. </b></span> 
                                <!-- Admin tab: navigate to contact view, Coordinators tab: navigate to coordinator mentors -->
                                <!-- Admin tab: navigate to contact view -->
                                <router-link v-if="activeTab === 'admin' && !$route.params.coordinator_id" :to="'/call-follow-up-v2/' + $route.params.id + '/' + sub_level.phone">
                                    {{ sub_level.name }}<br> <span class="text-dark">{{ sub_level.phone }}</span>
                                </router-link>
                                <!-- Coordinators tab: navigate to mentor contact view (mentors assigned to coordinator) -->
                                <router-link v-else-if="activeTab === 'coordinators' && sub_level.phone && !$route.params.coordinator_id" :to="'/call-follow-up-v2/' + $route.params.id + '/' + sub_level.phone">
                                    {{ sub_level.name }}<br> <span class="text-dark">{{ sub_level.phone }}</span>
                                </router-link>
                                <!-- Coordinator mentors detail page: navigate to mentor contact view -->
                                <router-link v-else-if="$route.params.coordinator_id && sub_level.phone" :to="'/call-follow-up-v2/' + $route.params.id + '/' + sub_level.phone">
                                    {{ sub_level.name }}<br> <span class="text-dark">{{ sub_level.phone }}</span>
                                </router-link>
                                <span v-else>
                                    {{ sub_level.name }}<br> <span class="text-dark">{{ sub_level.phone || 'N/A' }}</span>
                                </span>
                            </td>
                            <td class="text-primary font-dark text-right">
                                {{ sub_level.total_count }}
                            </td>
                            <td class="text-success font-dark text-right">
                                {{ sub_level.completed_count }}
                            </td>
                            <td class="text-danger font-dark text-right">
                                {{ sub_level.not_completed_count }}
                            </td>
                            <td class="text-danger font-dark text-right">
                                <div class="card-button dropdown">
                                    <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                                        :data-bs-target="'#actionSheetInset' + sub_level.phone">
                                        <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                                    </button>
                                </div>
                                <div class="modal fade action-sheet" :id="'actionSheetInset' + sub_level.phone"
                                    tabindex="-1" role="dialog">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Action</h5>
                                            </div>
                                            <div class="modal-body">
                                                <ul class="action-button-list">
                                                    <!-- <li>
                                                        <router-link
                                                            :to="'/call-follow-up/' + $route.params.id + '/' + sub_level.phone" data-bs-dismiss="modal">
                                                            <a href="javascript:void(0)" class="btn btn-list"
                                                                >
                                                                <span>
                                                                    <ion-icon name="eye-outline"></ion-icon> View
                                                                </span>
                                                            </a>
                                                        </router-link>
                                                    </li> -->
                                                    <li>
                                                        <a :href="'tel:' + sub_level.phone" class="btn btn-list">
                                                            <span>
                                                                <ion-icon name="call-outline"></ion-icon> Call
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li v-if="sub_level.phone">
                                                        <a :href="'https://wa.me/' + sub_level.phone + '?text='"
                                                            class="btn btn-list">
                                                            <span>
                                                                <ion-icon name="logo-whatsapp"></ion-icon> Whatsapp
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="action-divider"></li>
                                                    <li>
                                                        <a href="#" class="btn btn-list text-danger"
                                                            data-bs-dismiss="modal">
                                                            <span>
                                                                <ion-icon name="close-outline"></ion-icon> Cancel
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
export default {
    name: 'Nerpatham Report',
    components: {
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            meeting_list: [
                {
                    'id': 1,
                    'name': 'Secretariate'
                },
                {
                    'id': 2,
                    'name': 'Executive'
                },
                {
                    'id': 3,
                    'name': 'Departmental'
                },
                {
                    'id': 4,
                    'name': 'General Body'
                },
                {
                    'id': 5,
                    'name': 'Council'
                },
                {
                    'id': 6,
                    'name': 'Joint Secretariat'
                },
                {
                    'id': 7,
                    'name': 'Wisdom Day'
                },
                {
                    'id': 8,
                    'name': 'Special Meetings'
                },
            ],
            filter_meeting: '',
            search_mode:'',
            search_qry:'',
            filter_date_from: '',
            filter_date_to: '',
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            member_list: [],
            member: [],
            member_edit: true,
            orgnal_member_lists: [],
            trash_list: [],
            editable_id: '',
            editable: false,
            permissions: [],
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            attendance: 'A',
            attendance_remarks: '',
            search_qty: '',
            member_id: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            attendance_present: [],
            attendance_absent: [],
            filter_wing: '',
            isMember: '',
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            isEdit: false,
            count_total: 0,
            count_target: 0,
            level: [],
            nerpatham_target: '',
            target_title: 'ടാർഗറ്റ്',
            page_title: '',
            series: [0, 0],
            chartOptions: {
                chart: {
                    width: '100%',
                    type: 'pie',
                },
                colors: ['#64b167', '#db7491'],
                labels: ['Target', 'Total'],
                responsive: [{
                    breakpoint: 100,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            count_state: 0,
            count_unit: 0,
            count_zone: 0,
            count_district: 0,
            count_confirmed: 0.00,
            count_confirmed_reg: 0.00,
            count_balance_reg: 0.00,
            featuredFilterCounts: {},
            district_list:[],
            filter_district:'',
            zone_list:[],
            filter_zone:'',
            unit_list:[],
            filter_unit:'',
            zone:'',
            unit:'',
            filter_percentage:'',
            filter_sex:'',
            activeTab: 'admin', // 'admin' or 'coordinators'
            isUserCoordinator: false, // Whether the logged-in user is a coordinator
            userCoordinatorId: null, // The coordinator ID of the logged-in user
            userAdminType: null, // The admin_type of the coordinator ('admin' or 'coordinator')
            userAdminLevel: null, // The admin_level if admin_type is 'admin'
            loading_coordinator_check: false, // Loading state for coordinator check
            isCoordinatorViewingOwnMentors: false, // True when coordinator is viewing their own mentors directly

        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        minusToZero() {
            let value = this.count_target - this.count_total;
            if (value <= 0) {
                return '0';
            } else {
                return value.toFixed(2);
            }
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.getDistrictList();
            this.getZoneList(this.currentUser.district_id);
            this.getUnitList(this.currentUser.zone_id);
            
            // Check if we're viewing a coordinator's mentors
            if (this.$route.params.coordinator_id) {
                this.activeTab = 'coordinators';
                this.isCoordinatorViewingOwnMentors = true;
                // Always check coordinator status to get admin_type and admin_level
                this.checkIfUserIsCoordinator();
                this.getCoordinatorMentorsList();
            } else {
                // Always check if user is a coordinator first
                // If they are, redirect them to their coordinator page
                this.checkIfUserIsCoordinator();
            }
            
            this.$root.updateParent('Call Campign Report');
        }
        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        switchTab(tab) {
            this.activeTab = tab;
            
            // Clear previous data when switching tabs
            this.member_lists = [];
            this.loading_list = true;
            
            // If user is a coordinator
            if (this.isUserCoordinator) {
                if (tab === 'admin' && this.userAdminType === 'admin') {
                    // Admin type can view admin tab (mentors list using admin API)
                    // Stay on current page or go to main report page
                    if (this.$route.params.coordinator_id) {
                        // Currently on coordinator detail page, redirect to main page
                        this.$router.push('/call-follow-up-report-v2/' + this.$route.params.id);
                    }
                    // Call the admin API to get mentors list
                    this.getMembersList();
                } else if (tab === 'coordinators') {
                    // Show coordinator's mentors directly in the tab (no redirect)
                    // If we're on the main report page, just load the coordinator's mentors
                    if (!this.$route.params.coordinator_id) {
                        // Stay on main page, just load coordinator mentors data
                        this.getCoordinatorMentorsList();
                    } else {
                        // Already on coordinator detail page, just reload data
                        this.getCoordinatorMentorsList();
                    }
                }
            } else {
                // Not a coordinator - show admin list
                if (this.$route.params.coordinator_id) {
                    this.$router.push('/call-follow-up-report-v2/' + this.$route.params.id);
                }
                this.getMembersList();
            }
        },
        checkIfUserIsCoordinator() {
            // Check if the logged-in user is a coordinator for this campaign
            this.loading_coordinator_check = true;
            // Only set loading_list if we're not already on a coordinator detail page
            if (!this.$route.params.coordinator_id) {
                this.loading_list = true;
            }
            
            let data = {
                id: parseInt(this.$route.params.id),
            };
            
            UserService.authPostRequest('v2/check-user-coordinator', data).then(
                (response) => {
                    this.loading_coordinator_check = false;
                    if (response.data.status == 'success' && response.data.data.is_coordinator) {
                        // User is a coordinator
                        this.isUserCoordinator = true;
                        this.userCoordinatorId = response.data.data.coordinator_id;
                        this.userAdminType = response.data.data.admin_type;
                        this.userAdminLevel = response.data.data.admin_level;
                        this.isCoordinatorViewingOwnMentors = true;
                        
                        console.log('Coordinator info loaded:', {
                            admin_type: this.userAdminType,
                            admin_level: this.userAdminLevel
                        });
                        
                        // If already on coordinator detail page, don't redirect
                        if (this.$route.params.coordinator_id) {
                            // Already viewing coordinator mentors, just update the info
                            this.activeTab = 'coordinators';
                        } else {
                            // Not on coordinator page yet
                            if (response.data.data.admin_type === 'admin') {
                                // Admin type coordinators see both tabs
                                // Default to Admin tab and show mentors list using admin API
                                this.activeTab = 'admin';
                                this.getMembersList();
                            } else {
                                // Regular coordinators only see coordinator tab
                                // Show their assigned mentors directly (no redirect)
                                this.activeTab = 'coordinators';
                                this.getCoordinatorMentorsList();
                            }
                        }
                    } else {
                        // User is NOT a coordinator
                        // Show admin list (contacts assigned to users) only if they have permission
                        this.isUserCoordinator = false;
                        this.userCoordinatorId = null;
                        this.userAdminType = null;
                        this.userAdminLevel = null;
                        this.activeTab = 'admin';
                        this.getMembersList();
                    }
                },
                (error) => {
                    this.loading_coordinator_check = false;
                    this.loading_list = false;
                    this.isUserCoordinator = false;
                    console.error('Error checking coordinator status:', error);
                }
            );
        },
        getCoordinatorMentorsList() {
            // Use coordinator_id from route if available, otherwise use userCoordinatorId
            let coordinatorId = this.$route.params.coordinator_id ? parseInt(this.$route.params.coordinator_id) : this.userCoordinatorId;
            
            let data = {
                campaign_id: parseInt(this.$route.params.id),
                coordinator_id: coordinatorId,
                filter_district: this.filter_district ? this.filter_district : '',
                filter_zone: this.filter_zone ? this.filter_zone : '',
                filter_unit: this.filter_unit ? this.filter_unit : '',
                filter_percentage: this.filter_percentage ? this.filter_percentage : '',
                filter_sex: this.filter_sex ? this.filter_sex : '',
                search_qry: this.search_qry ? this.search_qry : '',
            }
            this.loading_list = true;
            
            UserService.authPostRequest('v2/get-coordinator-mentors-report', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_lists = response.data.data.list;
                        this.permissions = response.data.data.permissions;
                        this.count_target = response.data.data.total;
                        this.count_confirmed = response.data.data.done;
                        this.count_total = response.data.data.balance;
                        this.count_confirmed_reg = response.data.data.reg_total;
                        this.count_balance_reg = response.data.data.reg_balance;
                        this.featuredFilterCounts = response.data.data.featured_filter_counts || {};
                        // If viewing own coordinator data, just show campaign name
                        if (this.$route.params.coordinator_id) {
                            this.page_title = response.data.data.campaign.name + ' - ' + response.data.data.coordinator.name;
                        } else {
                            this.page_title = response.data.data.campaign.name;
                        }
                        this.loading_list = false;
                    } else {
                        this.loading_list = false;
                    }
                },
                (error) => {
                    this.loading_list = false;
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getMembersList() {
            let data = {
                id: parseInt(this.$route.params.id),
                filter_district: this.filter_district ? this.filter_district : '',
                filter_zone: this.filter_zone ? this.filter_zone : '',
                filter_unit: this.filter_unit ? this.filter_unit : '',
                filter_percentage: this.filter_percentage ? this.filter_percentage : '',
                filter_sex: this.filter_sex ? this.filter_sex : '',
                search_qry: this.search_qry ? this.search_qry : '',
            }
            this.loading_list = true;
            
            // Choose API endpoint based on active tab
            const endpoint = this.activeTab === 'admin' 
                ? 'v2/get-call-campign-report-v2'
                : 'v2/get-call-campign-coordinators-report';
            
            UserService.authPostRequest(endpoint, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_lists = response.data.data.list;
                        this.permissions = response.data.data.permissions;
                        this.count_target = response.data.data.total;
                        this.count_confirmed = response.data.data.done;
                        this.count_total = response.data.data.balance;
                        this.count_confirmed_reg = response.data.data.reg_total;
                        this.count_balance_reg = response.data.data.reg_balance;
                        this.featuredFilterCounts = response.data.data.featured_filter_counts || {};
                        this.page_title = response.data.data.campaign.name;
                        this.loading_list = false;
                    } else {
                        this.loading_list = false;
                    }
                },
                (error) => {
                    this.loading_list = false;
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getDistrictList() {
            let data = {}
            UserService.authPostRequest(`get-district-by-id`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.district_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getZoneList(district_id) {
            // this.loading_list = true;
            let data = {
                district_id: district_id
            }
            UserService.authPostRequest(`get-zone-by-id`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.zone_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getUnitList(zone_id) {
            // this.loading_list = true;
            let data = {
                zone_id: zone_id
            }
            UserService.authPostRequest(`get-unit-by-id`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.unit_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.stat-box .value {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1em;
    color: #27173E;
}


.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;

}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .total {
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1em;
    font-size: 26px;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px !important;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 0px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 10px;
    position: relative;
    z-index: 1;
}

.badge {
    border-radius: 0px !important;
}

/* Report Tabs Styling */
.report-tabs-container {
    display: flex;
    gap: 12px;
    width: 100%;
}

.report-tab-btn {
    flex: 1;
    padding: 8px 16px;
    border: 2px solid #1a418c;
    background-color: #ffffff;
    color: #1a418c;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.report-tab-btn:hover {
    background-color: #f0f4f8;
    border-color: #1a418c;
}

.report-tab-btn.active {
    background-color: #1a418c;
    color: #ffffff;
    border-color: #1a418c;
}

.report-tab-btn.active:hover {
    background-color: #153a6e;
    border-color: #153a6e;
}

/* Mobile responsive */
@media (max-width: 576px) {
    .report-tabs-container {
        gap: 8px;
    }
    
    .report-tab-btn {
        padding: 6px 12px;
        font-size: 13px;
        height: 36px;
    }
}
</style>